// extracted by mini-css-extract-plugin
export default {"PdfDocument":"Bmqrf","pdfWrapper":"LYdZO"};